module.exports = __webpack_public_path__ + "static/media/caret-circle-left.7a2ed91d.svg";